import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import UiKitButton from 'components/UiKit/Button';
import { paths } from 'routes/paths';

const CropZoneHeader = () => {
  const { action } = useParams();
  const history = useHistory();

  const title = action === 'edit' ? 'Edit' : 'Add';

  return (
    <div className="flex items-center mb-2">
      <div className="-ml-2.5">
        <UiKitButton
          aria-label="back"
          variant="text"
          style={{ fontSize: '1rem' }}
          icon={
            <FontAwesomeIcon
              icon={faChevronLeft}
              size="lg"
              style={{ visibility: 'visible', color: 'inherit' }}
            />
          }
          onClick={() => history.push(paths.properties)}
        />
      </div>
      <div className="flex-1 flex-col mx-2">
        <div className="text-3xl font-semibold leading-none">
          {title} Crop Zone
        </div>
      </div>
    </div>
  );
};

export default CropZoneHeader;
